import Column from "@components/column";
import React from "react";
import ShapeForm from "./form";
import ShapeList from "./list";

const ShapeSetup = () => {
  return (
    <Column>
      <ShapeForm />
      <ShapeList />
    </Column>
  );
};

export default ShapeSetup;
